import React, { useCallback } from 'react';
import Text from 'design-system/Text';
import { View } from 'react-native';
import { Button, ButtonGroup, Spacer } from 'design-system';
import useColors from 'hooks/useColors';
import Modal from 'utils/packages/Modal';
const ModalContent = ({ description, primaryButtonTitle, secondaryButtonTitle, tertiaryButtonTitle, onPrimaryButtonPress, onSecondaryButtonPress, onTertiaryButtonPress, }) => {
    const colors = useColors();
    const onPress = useCallback((callback) => {
        Modal.hide(() => {
            callback?.();
        });
    }, []);
    return (<View>
      <Spacer h={16}/>
      <Text TextThin-14 Secondary centered>
        {description}
      </Text>
      <Spacer h={16}/>
      <ButtonGroup margins={false}>
        {!!tertiaryButtonTitle && (<Button custom brandBorder textColor={colors.text.brand} title={tertiaryButtonTitle} onPress={() => onPress(onTertiaryButtonPress)}/>)}
        {!!secondaryButtonTitle && (<Button custom brandReversed title={secondaryButtonTitle} onPress={() => onPress(onSecondaryButtonPress)}/>)}

        {!!primaryButtonTitle && (<Button custom brand title={primaryButtonTitle} onPress={() => onPress(onPrimaryButtonPress)}/>)}
      </ButtonGroup>
      <Spacer h={16}/>
    </View>);
};
export default ModalContent;
